import { useState, useEffect } from 'react';

const CurrentTime = () => {
  const [Time, setTime] = useState('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      // Format the time: 18:51 (24-hour format without seconds)
      const formattedTime = now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Ensures 24-hour format
      });

      setTime(`${formattedTime}`);
    };

    updateTime(); // Call once immediately
    const interval = setInterval(updateTime, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return <div>{Time}</div>;
};

export default CurrentTime;
